import { Settings, VectorTile } from '@ais-ui/websockets';
import { useVectorTilesSettings } from '@ais-ui/user-settings';

export const getVectorTilesFromSettings = (
  settings: Settings,
): VectorTile[] => {
  return settings && settings?.vectorTiles ? settings.vectorTiles : [];
};

/**
 * Read hook for the vector-tile list. The user-settings collection engine
 * resolves blob-vs-service internally, so callers just consume `data` rather
 * than re-deriving the array from the raw settings blob.
 */
export const useVectorTileSettings = (): VectorTile[] => {
  return useVectorTilesSettings().data;
};

export interface VectorTileMutations {
  addVectorTile: (vectorTile: VectorTile) => Promise<void>;
  updateVectorTile: (vectorTile: VectorTile) => Promise<void>;
  deleteVectorTile: (id: string) => Promise<void>;
}

/**
 * Dual-write CRUD for vector tiles. Each op rewrites the authoritative blob
 * array (the guaranteed fallback) AND best-effort writes the matching per-item
 * operation to the new user-settings service. The caller owns id generation so
 * the same stable id reaches both the blob and the service upsert.
 */
export const useVectorTileMutations = (): VectorTileMutations => {
  const { add, update, remove } = useVectorTilesSettings();

  return {
    addVectorTile: add,
    updateVectorTile: update,
    deleteVectorTile: remove,
  };
};
